import type { Server, ServerForm } from "@/app/servers/types";
import type { ApiClient } from "@/lib/api";

export const updateServer = async (options: {
  client: ApiClient;
  id: string;
  server: Partial<ServerForm>;
}) => {
  const { client, id, server } = options;
  const { data } = await client.patch<Server>(`/workers/${id}`, server);
  return data;
};
